import type { Session } from '@supabase/supabase-js';
import { supabase } from './supabase';

export async function getVerifiedSupabaseSession(): Promise<Session | null> {
  if (!supabase) return null;

  const {
    data: { session },
  } = await supabase.auth.getSession();

  if (!session?.access_token || !session.user) {
    return null;
  }

  const { data, error } = await supabase.auth.getUser();
  if (error || !data.user?.id) {
    return null;
  }

  // getUser() can refresh an expired token internally. Return that refreshed
  // session instead of the stale snapshot captured before verification.
  const {
    data: { session: verifiedSession },
  } = await supabase.auth.getSession();

  if (
    !verifiedSession?.access_token ||
    !verifiedSession.user?.id ||
    verifiedSession.user.id !== data.user.id
  ) {
    return null;
  }

  return verifiedSession;
}
